
import React from 'react';
import moment from 'moment';
import to from 'await-to-js';
import { connect } from 'react-redux';
import { container } from 'op/container';
import update from 'immutability-helper';
import { Loader, Dimmer } from 'semantic-ui-react';
import merge from 'lodash/merge';
import { compose, branch, renderComponent, withProps, withHandlers, withState, lifecycle } from 'recompose';

import { withErrorHandling } from 'op/components/error';
import { withReportSaving, withReportValidation } from '../report.helper';

export const withReportEditing = compose(
	withState('synced', 'setSynced', false),
	withState('submitting', 'setSubmitting', false),
	connect((state,{ match: { params: {  person_id } } }) => ({
		reports: state.reports.editing || [],
		person: state.person.loaded.find(person => person.id.toString() === person_id),
	}), (dispatch) => ({
		setReport: (report) => 
			dispatch(container.resolve('actions').save_report(report)),
		justExit: (next) => 
			next ? container.resolve('history').push(next) : container.resolve('history').goBack(),
		clearAndExit:(report, next) =>  {
			dispatch(container.resolve('actions').remove_report(report));
			if (next){
				container.resolve('history').push(next);
			} else {
				container.resolve('history').goBack();
			}
		}
	})),
	withProps(({ reports, match }) => ({
		report: reports.find(report => report.id && report.id.toString() === match.params.report_id)
	})),
	withReportValidation,
	withReportSaving,
	withErrorHandling,
	lifecycle({
		async componentDidMount() {
			const {person, match, report, fetchReport, setReport, setSynced, online, throwError, justExit } = this.props;
			const id = parseInt(match.params.report_id);
			const person_id = person.person_id;
console.log("person_id"+person.person_id);
console.log("id"+person.id);
			if(!report){
				if(online && match.params.report_id){
					setReport(await fetchReport({ id, person_id }))
				} else {
					throwError({ 
						message: 'Report not foud localy',
					});
					justExit(`/person/${person_id}`);
				}
			} else if(online &&match.params.report_id) {
				const serverReport = await fetchReport({ id, person_id });
				if(moment(serverReport.lastUpdateTime).isAfter(report.lastUpdateTime)) {
					setReport(serverReport);
				}
			}

			setSynced(true);
		}
	}),
	withHandlers({
		sendReport: ({ report, setReport, saveReport, setSubmitting, dispatch }) => async (completed) => {
			setSubmitting(true);
			const [err, newReport] = await to(saveReport(completed));
			setSubmitting(false);

			if (err) {
				console.error(err);
			} else {
				if(report.id !== newReport.id){
					setTimeout(() => dispatch(container.resolve('actions').remove_report(report)), 100);
				}

				if(completed) {
					dispatch(container.resolve('actions').submit_report(report));
					container.resolve('history').push(`/person/${report.person_id}`);
				} else {
					dispatch(container.resolve('actions').save_report(report));
					container.resolve('history').push( `/person/${newReport.person_id}/report/${newReport.id}/edit`);
				}
			}
		},
		deleteReport: ({ report, deleteReport, clearAndExit, setSubmitting }) => async (next) => {
			setSubmitting(true);
			const [err, success] = await to(deleteReport());
			setSubmitting(false);

			if (!success || err) {
				console.error(err);
			} else {
				clearAndExit(report, next);
			}
		},
	}),
	branch(
		({ synced, report }) => !(synced && report),
		renderComponent(() => <Dimmer active><Loader content='Loading' /></Dimmer>)
	)
)